<button
  #ctaBtn
  class="action-button app-filter-button cta-button"
  [class.cta-button--success]="successState && !loading"
  type="button"
  (click)="handleClick()"
  [disabled]="isDisabled"
  [attr.aria-busy]="loading || null"
  [attr.aria-disabled]="isDisabled || null">

  <i *ngIf="!loading" class="pi {{ icon }}" aria-hidden="true"></i>
  <i *ngIf="loading" class="pi pi-spin pi-spinner" aria-hidden="true"></i>

  <span class="action-button-label">{{ resolvedLabel | translate }}</span>

  <span *ngIf="successState && !loading" class="cta-success-indicator" aria-hidden="true">✓</span>
</button>
